import React, { useEffect } from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';
import { BASE_URL } from '../Config/Base';





const CorpLifehereMain = () => {

 useEffect(()=>{
  getCorpCapandcontent()
  getCorpCapandimg()
 },[])

    const token = JSON.parse(localStorage.getItem('usertoken'));
  
   
function getCorpCapandcontent()
{

  fetch(`${BASE_URL}/Kdpcorp/GetCorpLHContent`, {
      method:'GET',

    headers : {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Authorization": "Bearer " +`${token}`,

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
    },


})

.then(response => response.json())


.then(data => {
console.log("Section",data)

localStorage.setItem("corpLHContentData", JSON.stringify(data));
});
}
  
function getCorpCapandimg(){
 
 

  fetch(`${BASE_URL}/Kdpcorp/GetCorpLHImages`, {
    method:'GET',

  headers : {

    "Content-type": "application/json",

    "Accept": "application/json",

    "Authorization": "Bearer " +`${token}`,

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  },


})

.then(response => response.json())


.then(data => {
console.log("Section",data)

localStorage.setItem("CorpLHImagesData", JSON.stringify(data));

});

}

  

  return (
    <>
  
    <div className='Corp-addmainPicLife' >
    <div className='Corp-addmain'>

    <div className="Corp-addgrid-layout">
  <div className="Corp-addmain-top">
    <div className='Corp-addmain-back'>
    <Link to='/Corpsection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
    </div> 
    <span>Life here</span>
    
    </div>
    </div>

    <div className="holder">


    <div className="dot dot5 con ">
      
      </div>
  
      <div className="dot dot6 Img ">
        
      </div> 
  

   
    <ul id='Corp-sectionMain' className="titles" >

  
   

    {/* <li  id="Corp-touchMainC">
   
    <nav id="Corp-section-nav"> */}

<label for="Corp-touchC" id="corpsectionlable">

  {/* <i  onClick={CorpopensectionC}></i>
  <i  onClick={CorpclosesectionC}></i> */}
  &nbsp;<li id ="Corp-sectionC-head" className="title5 title-animate"><Link to="/CorpLHContent" id="Corplifetext" className='Corphover'>Content</Link></li>
  </label>               
<input type="checkbox" id="Corp-touchC" /> 

<ul class="Corp-slide" id="Corp-slideC">

<ul className='CorpList'>

    {/* <li><Link to="/CorpGBContent"><p>Content</p></Link></li>
    <li><Link to="/CorpGBImages"><p>Images</p></Link></li> */}

</ul>
</ul>

{/* </nav> 

</li> */}


<li  id="Corp-touchMainD">
      <nav id="Corp-section-nav">

<label for="Corp-touchD" id="corpsectionlable" >

  {/* <i  onClick={CorpopensectionD}></i>
  <i  onClick={CorpclosesectionD}></i> */}
  &nbsp;<li id ="Corp-sectionD-head" className="title6 title-animate"><Link to="/CorpLHImages" id="Corplifetext"><span>Images</span></Link></li>
  </label>               
<input type="checkbox" id="Corp-touchD" /> 

<ul class="Corp-slide" id="Corp-slideD">

<ul className='CorpList'>

    {/* <li><Link to="/CorpCareers"><p>Content</p></Link></li> */}
   
</ul>

</ul>

</nav>

</li>


    </ul>




    {/* </div>  */}

    </div>


  
    </div>


    
     </div>

    

    </>
  )
}

export default CorpLifehereMain